// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copilot Chat Custom Styles */
.animate-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.ls-1 {
    letter-spacing: 0.05rem;
}

.x-small-badge {
    font-size: 0.65rem;
    padding: 0.25rem 0.5rem;
}

/* KaTeX Math Overrides */
.katex-display {
    margin: 1em 0;
    overflow-x: auto;
    overflow-y: hidden;
}

.markdown-body p {
    line-height: 1.6;
}

.hover-shadow:hover {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    transform: translateY(-2px);
}

.transition {
    transition: all 0.2s ease-in-out;
}

/* --- AcademicOS Classroom: Premium Faculty Theme --- */

:root {
    --classroom-primary: #0d6efd;
    --classroom-bg: #f8f9fa;
    --classroom-card-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    --classroom-dark-bg: #1a1d21;
}

/* Base Body Style */
.classroom-body {
    background-color: var(--classroom-bg);
    font-family: 'Inter', -apple-system, sans-serif;
    color: #2d3436;
}

/* Premium Card Design */
.faculty-card {
    border: none !important;
    border-radius: 16px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #ffffff;
    box-shadow: var(--classroom-card-shadow);
}

.faculty-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

/* Typography Utility */
.ls-1 {
    letter-spacing: 0.05rem;
}

.uppercase {
    text-transform: uppercase;
}

.x-small {
    font-size: 0.75rem;
}

/* Soft Badges */
.badge-soft-primary {
    background-color: rgba(13, 110, 253, 0.1);
    color: #0d6efd;
    font-weight: 600;
}

.badge-soft-success {
    background-color: rgba(25, 135, 84, 0.1);
    color: #198754;
    font-weight: 600;
}

/* CoPilot Chat Workspace UI */
.chat-container {
    background: #ffffff;
    border-radius: 20px;
    height: 75vh;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0,0,0,0.05);
}

.chat-bubble-assistant {
    background-color: #f1f3f5;
    border-radius: 0 15px 15px 15px;
    padding: 15px;
    max-width: 85%;
    margin-bottom: 20px;
    border-left: 4px solid var(--classroom-primary);
}

.chat-bubble-user {
    background-color: var(--classroom-primary);
    color: white;
    border-radius: 15px 15px 0 15px;
    padding: 15px;
    max-width: 80%;
    margin-left: auto;
    margin-bottom: 20px;
}

/* Glassmorphism for the Input Bar */
.chat-input-area {
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 0.8);
    border-top: 1px solid rgba(0,0,0,0.05);
    padding: 20px;
}

/* KaTeX and Markdown Refinements */
.markdown-body {
    font-size: 0.95rem;
    line-height: 1.7;
}

.markdown-body h1, .markdown-body h2 {
    border-bottom: none;
    font-weight: 700;
    color: #1a1d21;
}`, "",{"version":3,"sources":["webpack://./src/components/Projects/Copilot.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,kCAAkC;AACtC;;AAEA;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wDAAwD;IACxD,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,wDAAwD;;AAExD;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,wDAAwD;IACxD,4BAA4B;AAChC;;AAEA,oBAAoB;AACpB;IACI,qCAAqC;IACrC,+CAA+C;IAC/C,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,iDAAiD;IACjD,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA,uBAAuB;AACvB;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,sCAAsC;IACtC,aAAa;AACjB;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":["/* Copilot Chat Custom Styles */\r\n.animate-spin {\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    from { transform: rotate(0deg); }\r\n    to { transform: rotate(360deg); }\r\n}\r\n\r\n.ls-1 {\r\n    letter-spacing: 0.05rem;\r\n}\r\n\r\n.x-small-badge {\r\n    font-size: 0.65rem;\r\n    padding: 0.25rem 0.5rem;\r\n}\r\n\r\n/* KaTeX Math Overrides */\r\n.katex-display {\r\n    margin: 1em 0;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n}\r\n\r\n.markdown-body p {\r\n    line-height: 1.6;\r\n}\r\n\r\n.hover-shadow:hover {\r\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.transition {\r\n    transition: all 0.2s ease-in-out;\r\n}\r\n\r\n/* --- AcademicOS Classroom: Premium Faculty Theme --- */\r\n\r\n:root {\r\n    --classroom-primary: #0d6efd;\r\n    --classroom-bg: #f8f9fa;\r\n    --classroom-card-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\r\n    --classroom-dark-bg: #1a1d21;\r\n}\r\n\r\n/* Base Body Style */\r\n.classroom-body {\r\n    background-color: var(--classroom-bg);\r\n    font-family: 'Inter', -apple-system, sans-serif;\r\n    color: #2d3436;\r\n}\r\n\r\n/* Premium Card Design */\r\n.faculty-card {\r\n    border: none !important;\r\n    border-radius: 16px !important;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    background: #ffffff;\r\n    box-shadow: var(--classroom-card-shadow);\r\n}\r\n\r\n.faculty-card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* Typography Utility */\r\n.ls-1 {\r\n    letter-spacing: 0.05rem;\r\n}\r\n\r\n.uppercase {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.x-small {\r\n    font-size: 0.75rem;\r\n}\r\n\r\n/* Soft Badges */\r\n.badge-soft-primary {\r\n    background-color: rgba(13, 110, 253, 0.1);\r\n    color: #0d6efd;\r\n    font-weight: 600;\r\n}\r\n\r\n.badge-soft-success {\r\n    background-color: rgba(25, 135, 84, 0.1);\r\n    color: #198754;\r\n    font-weight: 600;\r\n}\r\n\r\n/* CoPilot Chat Workspace UI */\r\n.chat-container {\r\n    background: #ffffff;\r\n    border-radius: 20px;\r\n    height: 75vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border: 1px solid rgba(0,0,0,0.05);\r\n}\r\n\r\n.chat-bubble-assistant {\r\n    background-color: #f1f3f5;\r\n    border-radius: 0 15px 15px 15px;\r\n    padding: 15px;\r\n    max-width: 85%;\r\n    margin-bottom: 20px;\r\n    border-left: 4px solid var(--classroom-primary);\r\n}\r\n\r\n.chat-bubble-user {\r\n    background-color: var(--classroom-primary);\r\n    color: white;\r\n    border-radius: 15px 15px 0 15px;\r\n    padding: 15px;\r\n    max-width: 80%;\r\n    margin-left: auto;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Glassmorphism for the Input Bar */\r\n.chat-input-area {\r\n    backdrop-filter: blur(10px);\r\n    background: rgba(255, 255, 255, 0.8);\r\n    border-top: 1px solid rgba(0,0,0,0.05);\r\n    padding: 20px;\r\n}\r\n\r\n/* KaTeX and Markdown Refinements */\r\n.markdown-body {\r\n    font-size: 0.95rem;\r\n    line-height: 1.7;\r\n}\r\n\r\n.markdown-body h1, .markdown-body h2 {\r\n    border-bottom: none;\r\n    font-weight: 700;\r\n    color: #1a1d21;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
